const usAreaCodes = [
	'201',
	'202',
	'203',
	'205',
	'206',
	'207',
	'208',
	'209',
	'210',
	'212',
	'213',
	'214',
	'215',
	'216',
	'217',
	'218',
	'219',
	'220',
	'224',
	'225',
	'228',
	'229',
	'231',
	'234',
	'239',
	'240',
	'248',
	'251',
	'252',
	'253',
	'254',
	'256',
	'260',
	'262',
	'264',
	'267',
	'268',
	'269',
	'270',
	'272',
	'276',
	'281',
	'283',
	'284',
	'301',
	'302',
	'303',
	'304',
	'305',
	'307',
	'308',
	'309',
	'310',
	'312',
	'313',
	'314',
	'315',
	'316',
	'317',
	'318',
	'319',
	'320',
	'321',
	'323',
	'325',
	'330',
	'331',
	'334',
	'336',
	'337',
	'339',
	'340',
	'341',
	'345',
	'346',
	'347',
	'351',
	'352',
	'360',
	'361',
	'364',
	'380',
	'385',
	'386',
	'401',
	'402',
	'403',
	'404',
	'405',
	'406',
	'407',
	'408',
	'409',
	'410',
	'412',
	'413',
	'414',
	'415',
	'417',
	'419',
	'423',
	'424',
	'425',
	'430',
	'432',
	'434',
	'435',
	'440',
	'441',
	'442',
	'443',
	'456',
	'469',
	'470',
	'473',
	'475',
	'478',
	'479',
	'480',
	'484',
	'500',
	'501',
	'502',
	'503',
	'504',
	'505',
	'507',
	'508',
	'509',
	'510',
	'511',
	'512',
	'513',
	'515',
	'516',
	'517',
	'518',
	'520',
	'530',
	'531',
	'534',
	'540',
	'541',
	'551',
	'557',
	'559',
	'561',
	'562',
	'563',
	'564',
	'567',
	'570',
	'571',
	'573',
	'574',
	'575',
	'586',
	'600',
	'601',
	'602',
	'603',
	'605',
	'606',
	'607',
	'608',
	'609',
	'610',
	'611',
	'612',
	'615',
	'616',
	'617',
	'618',
	'619',
	'620',
	'623',
	'626',
	'628',
	'629',
	'630',
	'631',
	'636',
	'640',
	'641',
	'646',
	'649',
	'650',
	'651',
	'657',
	'658',
	'660',
	'661',
	'662',
	'664',
	'665',
	'667',
	'669',
	'670',
	'671',
	'678',
	'681',
	'682',
	'684',
	'689',
	'700',
	'701',
	'702',
	'703',
	'704',
	'706',
	'707',
	'708',
	'709',
	'710',
	'711',
	'712',
	'713',
	'714',
	'715',
	'716',
	'717',
	'718',
	'719',
	'720',
	'721',
	'724',
	'725',
	'726',
	'727',
	'731',
	'732',
	'733',
	'734',
	'737',
	'740',
	'743',
	'747',
	'749',
	'750',
	'754',
	'757',
	'758',
	'759',
	'760',
	'762',
	'763',
	'764',
	'765',
	'767',
	'769',
	'770',
	'771',
	'772',
	'773',
	'774',
	'775',
	'781',
	'784',
	'785',
	'786',
	'787',
	'800',
	'801',
	'802',
	'803',
	'804',
	'805',
	'806',
	'808',
	'809',
	'810',
	'811',
	'812',
	'813',
	'814',
	'815',
	'816',
	'817',
	'818',
	'820',
	'825',
	'828',
	'829',
	'830',
	'832',
	'833',
	'835',
	'843',
	'844',
	'845',
	'847',
	'848',
	'850',
	'855',
	'856',
	'857',
	'858',
	'859',
	'860',
	'862',
	'863',
	'864',
	'865',
	'866',
	'867',
	'868',
	'869',
	'870',
	'872',
	'877',
	'878',
	'880',
	'881',
	'888',
	'900',
	'901',
	'903',
	'904',
	'906',
	'907',
	'908',
	'910',
	'911',
	'913',
	'914',
	'915',
	'916',
	'917',
	'918',
	'919',
	'920',
	'925',
	'927',
	'928',
	'929',
	'931',
	'935',
	'936',
	'937',
	'938',
	'939',
	'940',
	'941',
	'947',
	'949',
	'951',
	'952',
	'954',
	'956',
	'957',
	'959',
	'970',
	'971',
	'972',
	'973',
	'975',
	'976',
	'978',
	'979',
	'980',
	'984',
	'985',
	'986',
	'987',
	'989',
];

export default usAreaCodes;
